import { NavigationContextType } from './navigation.types';

import { StepName } from '~/core/enums';

export const navigationContextInitialState: NavigationContextType = {
  navSteps: [],
  enabledSteps: [],
  nextStep: StepName.material,
  goToAndFocusStep: () => null,
  goToNextStep: () => null,
};
